var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDebtConsolidation40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3577 11.4402H6.64229C5.56269 11.4402 4.6875 12.3154 4.6875 13.395V27.7301C4.6875 28.8097 5.56269 29.6849 6.64229 29.6849H33.3577C34.4373 29.6849 35.3125 28.8097 35.3125 27.7301V13.395C35.3125 12.3154 34.4373 11.4402 33.3577 11.4402Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 32.0652C29.3239 32.0652 31.5625 29.8266 31.5625 27.0652C31.5625 24.3038 29.3239 22.0652 26.5625 22.0652C23.8011 22.0652 21.5625 24.3038 21.5625 27.0652C21.5625 29.8266 23.8011 32.0652 26.5625 32.0652Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9375 30.8152C34.0441 30.8152 36.5625 28.2968 36.5625 25.1902C36.5625 22.0836 34.0441 19.5652 30.9375 19.5652C27.8309 19.5652 25.3125 22.0836 25.3125 25.1902C25.3125 28.2968 27.8309 30.8152 30.9375 30.8152Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7058 27.3777H31.3933",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 23.0027H32.1875",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4688 25.1902H31.4062",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.625 23.0027C29.9346 23.0027 29.375 23.4924 29.375 24.0964C29.375 24.7005 29.9346 25.1902 30.625 25.1902",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 25.1902C31.9404 25.1902 32.5 25.6799 32.5 26.2839C32.5 26.888 31.9404 27.3777 31.25 27.3777",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9258 23.0344V21.7527",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9258 28.5886V27.3069",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDebtConsolidation40);
export default __webpack_public_path__ + "static/media/pictogramBeaconDebtConsolidation40.07bfe9aec727d9e92ea32eaa42df794b.svg";
export { ForwardRef as ReactComponent };